<template>
  <div class="datos">
    <div class="container">
      <div class="row">
        <div class="form-group">
          <label for="exampleFormControlSelect1">Datos a mostrar</label>
          <select
            class="form-control"
            id="exampleFormControlSelect1"
            style="width: auto"
            v-on:change="ChangeDataToShow($event)"
          >
            <option value="0">Nuevos</option>
            <option value="1">Atendidos / Contactados</option>
          </select>
        </div>
      </div>
    </div>

    <br /><br />
    <div v-for="(datos, index) in dataToShow" v-bind:key="index">
      <div class="card" v-bind:id="'card-' + datos.tbldatos_id">
        <div class="card-body">
          <div class="card-title text-center">
            {{ datos.tbldatos_nombreCompleto }}
          </div>
          <div class="card-text">
            <div class="row">
              <p class="text-muted">ID: {{ datos.tbldatos_id }}</p>
            </div>
            <div class="row">
              <p class="text-muted">Recibido: {{ datos.tbldatos_created }}</p>
            </div>
            <div class="row">
              <p>
                <span class="text-muted">Teléfono:</span>
                {{ datos.tbldatos_telefono }}
              </p>
            </div>
            <div class="row">
              <p>
                <span class="text-muted">Correo:</span>
                {{ datos.tbldatos_correo }}
              </p>
            </div>
            <div class="row">
              <p v-if="datos.tbldatos_valoracionMedica == 1">
                <span class="text-muted">¿Cuenta con valoración médica?:</span>
                Si
              </p>
              <p v-else>
                <span class="text-muted"
                  >¿Cuenta con valoración médica?: No</span
                >
              </p>
            </div>
            <div class="row">
              <p class="text-muted">Detalles</p>
              <p>{{ datos.tbldatos_detalles }}</p>
            </div>
            <div class="row" v-if="datos.tbl_datos_status == 0">
              <button class="btn btn-gob-gold" style="width: auto; margin-left: auto; margin-right: auto;" v-on:click="MarkAsRead(datos.tbldatos_id)">Marcar como atendido / contactado</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<style>
.card {
  margin: 8px;
  border-radius: 16px;
  padding: 8px;
  background-color: #eceff1; /* Material Blue Gray 50 */
}
</style>

<script>
import axios from "axios";
import auth from "@/auth/auth";

let axiosConfig = {
  headers: {
    "Content-Type": "application/json",
  },
};

// Importamos JQuery
const $ = require("jquery");
// Lo declaramos globalmente
window.$ = $;
$(document).ready(function () {
  console.log("Ready");
});

export default {
  name: "Datos",
  data() {
    return {
      dataToShow: [],
      filterData: 0, // 0 Nuevos, 1 atendidos
    };
  },
  computed: {
    userLoggedID() {
      return auth.getUserIDLogged();
    },
  },
  methods: {
    ShowAlert(title, message, icon) {
      this.$swal({
        title: title,
        text: message,
        type: icon,
      }).then((result) => {
        if (result.isConfirmed) {
          //this.clearModel();
        }
      });
    },

    ShowDetails(title, message) {
      this.$swal({
        title: title,
        html: message,
      }).then((result) => {
        if (result.isConfirmed) {
          //this.clearModel();
        }
      });
    },

    GetData() {
      var dat = {
        params: {
          ius: auth.getUserIDLogged(),
          filter: this.filterData,
        },
      };

      axios
        .get(
          "https://saludnl.gob.mx/apis/cancerinfantil/v1/data.php/",
          dat,
          axiosConfig
        )
        .then((result) => {
          this.dataToShow = result.data;
        })
        .catch((error) => {
          this.ShowAlert(
            "Error",
            "Ocurrió un error al obtener la información. [" + error + "`]",
            "error"
          );
        })
        .finally(() => {
          //Perform action in always
        });
    },

    ChangeDataToShow(e) {
      this.filterData = e.target.value;
      this.GetData();
    },

    MarkAsRead(elementID) {
      // Marcar como atendido
      var bodyFormData = new FormData();
      bodyFormData.append("newVal", 1);
      bodyFormData.append("elID", elementID);

      axios
        .post(
          "https://saludnl.gob.mx/apis/cancerinfantil/v1/data.php/",
          bodyFormData,
          axiosConfig
        )
        .then((result) => {
          console.info("SUCCESS SEND");
          console.info(result);
          this.ShowAlert("Exito", "El estado ha sido cambiado exitosamente.", "success");
          this.GetData();
        })
        .catch((error) => {
          console.info("ERROR SEND");
          this.ShowAlert(
            "Error",
            "Intenta cambiar el estado nuevamente, [" + error + "`]",
            "error"
          );
        })
        .finally(() => {
          //Perform action in always
        });
    },
  },

  created() {
    this.GetData();
  },
};
</script>
